export default {
  id: 10,
  title: 'Target #10 - Cloaked Spirits',
  url: 'https://cssbattle.dev/play/10',
  colors: ['#62306D', '#F7EC7D', '#AA445F', '#E38F66'],
  solution:
    '<a a><a b><a c><style>body{background:#62306D}a{position:fixed;top:200;left:50;width:100;height:200;background:#F7EC7D;}a::after{content:"";position:absolute;top:-50;width:60;height:60;background:#E38F66;border-radius:50%;border:20px solid #AA445F}a[b]{top:100;left:150}a[b]::after{background:#AA445F;border-color:#E38F66}a[c]{left:250}</style>',
}
